export const forgotPasswordContainer = "flex items-center justify-center min-h-screen bg-gray-200 dark:bg-gray-900 px-4";

export const formContainer = "flex flex-col justify-center w-full max-w-md p-6 bg-white rounded-lg shadow-lg dark:bg-gray-800";

export const iconContainer = "flex justify-center items-center mb-5";

export const keyIcon = "w-12 h-12 text-blue-500 bg-blue-100 p-2 rounded-full";

export const titleContainer = "mb-5 sm:mb-8 text-center";

export const heading = "text-2xl font-semibold text-gray-800 dark:text-white";

export const subText = "text-sm text-gray-500 dark:text-gray-400";

export const inputField = "w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500 transition";

export const loginButton = "w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 mt-4 transition";

export const passwordRememberContainer = "flex items-center justify-center gap-1 text-sm text-gray-500 dark:text-gray-400 mt-3";

export const forgotPassword = "text-blue-500 hover:text-blue-600 dark:text-blue-400";

export const errorText = "text-red-500 text-sm mt-1";